if (window.location.pathname === "/ambassadorApplication") {
  $("#brandAmbassadorApplication").on("submit",function(event) {
    let region_checkboxes = $("input[name='regions']:checked");
    let plan_checkboxes = $("input[name='planningMethods']:checked");

    if (region_checkboxes.length === 0) {
      alert('Please select at least one region you travel to');
      event.preventDefault();
    } else if (plan_checkboxes.length === 0) {
      alert('Please select at least one planning method you use in AdventureGenie');
      event.preventDefault();
    };
  });
};